// AUTO-GENERATED — do not edit. Run `pnpm build` in packages/domain-data.
// Source: business/ishvaram/data/domain/astrology/rashis.yaml

export type RashiId =
  | "mesh"
  | "vrishabh"
  | "mithun"
  | "kark"
  | "singh"
  | "kanya"
  | "tula"
  | "vrishchik"
  | "dhanu"
  | "makar"
  | "kumbh"
  | "meen";

export interface Rashi {
  /** Vedic id, e.g. "mesh" */
  id: RashiId;
  name_en: string;
  name_hi: string;
  name_sa: string;
  /** Vedic id duplicated for URL slugs */
  slug: string;
  /** 1-indexed, Aries=1 */
  number: number;
  degree_start: number;
  degree_end: number;
  element: string;
  /** cardinal | fixed | mutable */
  quality: string;
  /** ruling planet id */
  ruler: string;
  /** optional co-ruler (Scorpio→ketu, Aquarius→rahu, Pisces→ketu) */
  co_ruler?: string;
  symbol: string;
  gender: string;
  nature: string;
  body_part: string;
  lucky_color: string;
  lucky_number: number;
  compatible_rashis: string[];
}

export const rashis: readonly Rashi[] = [
  {
    id: "mesh",
    name_en: "Aries",
    name_hi: "मेष",
    name_sa: "Mesha",
    slug: "mesh",
    number: 1,
    degree_start: 0,
    degree_end: 30,
    element: "fire",
    quality: "cardinal",
    ruler: "mars",
    symbol: "Ram",
    gender: "male",
    nature: "fiery",
    body_part: "head",
    lucky_color: "red",
    lucky_number: 9,
    compatible_rashis: ["singh", "dhanu", "mithun"],
  },
  {
    id: "vrishabh",
    name_en: "Taurus",
    name_hi: "वृषभ",
    name_sa: "Vrishabha",
    slug: "vrishabh",
    number: 2,
    degree_start: 30,
    degree_end: 60,
    element: "earth",
    quality: "fixed",
    ruler: "venus",
    symbol: "Bull",
    gender: "female",
    nature: "earthy",
    body_part: "face_throat",
    lucky_color: "white",
    lucky_number: 6,
    compatible_rashis: ["kanya", "makar", "kark"],
  },
  {
    id: "mithun",
    name_en: "Gemini",
    name_hi: "मिथुन",
    name_sa: "Mithuna",
    slug: "mithun",
    number: 3,
    degree_start: 60,
    degree_end: 90,
    element: "air",
    quality: "mutable",
    ruler: "mercury",
    symbol: "Twins",
    gender: "male",
    nature: "airy",
    body_part: "arms_shoulders",
    lucky_color: "green",
    lucky_number: 5,
    compatible_rashis: ["tula", "kumbh", "mesh"],
  },
  {
    id: "kark",
    name_en: "Cancer",
    name_hi: "कर्क",
    name_sa: "Karka",
    slug: "kark",
    number: 4,
    degree_start: 90,
    degree_end: 120,
    element: "water",
    quality: "cardinal",
    ruler: "moon",
    symbol: "Crab",
    gender: "female",
    nature: "watery",
    body_part: "chest_stomach",
    lucky_color: "white",
    lucky_number: 2,
    compatible_rashis: ["vrishchik", "meen", "vrishabh"],
  },
  {
    id: "singh",
    name_en: "Leo",
    name_hi: "सिंह",
    name_sa: "Simha",
    slug: "singh",
    number: 5,
    degree_start: 120,
    degree_end: 150,
    element: "fire",
    quality: "fixed",
    ruler: "sun",
    symbol: "Lion",
    gender: "male",
    nature: "fiery",
    body_part: "heart",
    lucky_color: "gold",
    lucky_number: 1,
    compatible_rashis: ["mesh", "dhanu", "mithun"],
  },
  {
    id: "kanya",
    name_en: "Virgo",
    name_hi: "कन्या",
    name_sa: "Kanya",
    slug: "kanya",
    number: 6,
    degree_start: 150,
    degree_end: 180,
    element: "earth",
    quality: "mutable",
    ruler: "mercury",
    symbol: "Virgin",
    gender: "female",
    nature: "earthy",
    body_part: "intestines",
    lucky_color: "green",
    lucky_number: 5,
    compatible_rashis: ["vrishabh", "makar", "kark"],
  },
  {
    id: "tula",
    name_en: "Libra",
    name_hi: "तुला",
    name_sa: "Tula",
    slug: "tula",
    number: 7,
    degree_start: 180,
    degree_end: 210,
    element: "air",
    quality: "cardinal",
    ruler: "venus",
    symbol: "Scales",
    gender: "male",
    nature: "airy",
    body_part: "kidneys_lower_back",
    lucky_color: "white",
    lucky_number: 6,
    compatible_rashis: ["mithun", "kumbh", "mesh"],
  },
  {
    id: "vrishchik",
    name_en: "Scorpio",
    name_hi: "वृश्चिक",
    name_sa: "Vrishchika",
    slug: "vrishchik",
    number: 8,
    degree_start: 210,
    degree_end: 240,
    element: "water",
    quality: "fixed",
    ruler: "mars",
    co_ruler: "ketu",
    symbol: "Scorpion",
    gender: "female",
    nature: "watery",
    body_part: "reproductive_organs",
    lucky_color: "red",
    lucky_number: 9,
    compatible_rashis: ["kark", "meen", "kanya"],
  },
  {
    id: "dhanu",
    name_en: "Sagittarius",
    name_hi: "धनु",
    name_sa: "Dhanu",
    slug: "dhanu",
    number: 9,
    degree_start: 240,
    degree_end: 270,
    element: "fire",
    quality: "mutable",
    ruler: "jupiter",
    symbol: "Archer",
    gender: "male",
    nature: "fiery",
    body_part: "thighs",
    lucky_color: "yellow",
    lucky_number: 3,
    compatible_rashis: ["mesh", "singh", "tula"],
  },
  {
    id: "makar",
    name_en: "Capricorn",
    name_hi: "मकर",
    name_sa: "Makara",
    slug: "makar",
    number: 10,
    degree_start: 270,
    degree_end: 300,
    element: "earth",
    quality: "cardinal",
    ruler: "saturn",
    symbol: "Sea-Goat",
    gender: "female",
    nature: "earthy",
    body_part: "knees",
    lucky_color: "blue",
    lucky_number: 8,
    compatible_rashis: ["vrishabh", "kanya", "meen"],
  },
  {
    id: "kumbh",
    name_en: "Aquarius",
    name_hi: "कुंभ",
    name_sa: "Kumbha",
    slug: "kumbh",
    number: 11,
    degree_start: 300,
    degree_end: 330,
    element: "air",
    quality: "fixed",
    ruler: "saturn",
    co_ruler: "rahu",
    symbol: "Water-Bearer",
    gender: "male",
    nature: "airy",
    body_part: "ankles_calves",
    lucky_color: "blue",
    lucky_number: 8,
    compatible_rashis: ["mithun", "tula", "dhanu"],
  },
  {
    id: "meen",
    name_en: "Pisces",
    name_hi: "मीन",
    name_sa: "Meena",
    slug: "meen",
    number: 12,
    degree_start: 330,
    degree_end: 360,
    element: "water",
    quality: "mutable",
    ruler: "jupiter",
    co_ruler: "ketu",
    symbol: "Fish",
    gender: "female",
    nature: "watery",
    body_part: "feet",
    lucky_color: "yellow",
    lucky_number: 3,
    compatible_rashis: ["kark", "vrishchik", "makar"],
  },
] as const;

export const rashiMap: Readonly<Record<string, Rashi>> = Object.fromEntries(
  rashis.map((r) => [r.id, r])
);
